module.exports = __webpack_public_path__ + "static/media/recurring_expense.92ee727b.png";